/* eslint-disable */
import React from 'react';
import url from '../../config/url';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './Catalogue.css';

var branchMetadata = [];
var titleMetadata = [];

class Dropdown extends React.Component
{

    constructor(props){
        super(props);
        this.state = {
            branch:new Array(),
            title:new Array(),
            clearable:true,
            branchName:'',
            
            
        }
        this.handleBranchChange = this.handleBranchChange.bind(this);
    }

    handleBranchChange(e){
        console.log(e);
        this.props.getId(e.value);
    }



    componentDidMount(){
        //api call to populate dropdown
        if(branchMetadata.length === 0){
            console.log('calling branches');
            
            axios.get(url + 'getAllActiveBranches').then(response => {
                if(response.data.status)
                {
                    var branches = response.data.successObject;
                    
                    for(let i = 0 ; i < branches.length; i++){
                        var obj = {value:{
                            id:branches[i].id,
                            bookTypeId:''},label:branches[i].id  + '-'+branches[i].branchName}
                        branchMetadata.push(obj);
                    }
                    
                }
            }).catch(err => {
                console.log(err);
            })
        }
        this.setState({branch:branchMetadata});        
    }

    render(){
        return(
            <React.Fragment>
               
                <Select
                    name="branchDD"
                    style = {{marginTop:30}}
                    onChange = {value =>
                    { 
                        this.setState({branchName:value})
                        this.handleBranchChange(value)
                    }} 
                    value = {this.state.branchName}
                    options={this.state.branch}
                    searchable = {true}             
                    clearable={false}
                    placeholder = 'Select Branch'
                /> 
                {/* <Select
                    name="titleDD"
                    style = {{marginTop:20}}
                    //  onChange={this.handleSelectBranch}
                    onChange = {value =>
                    {
                        this.setState({titleName: value });
                        this.handleBranchChange(value, "title")
                    }}
                    value = {this.state.titleName}
                    options={this.state.title}
                    searchable = {true}             
                    clearable={false}
                    placeholder = 'Select Title'

                /> */}
            </ React.Fragment>
        )
    }
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/Components/Magazine-Catalogue/Dropdown.js